export const CONFIRMED_GET_MEDICINE_TYPES = "CONFIRMED_GET_MEDICINE_TYPES";
export const CONFIRMED_CREATE_MEDICINE_TYPE = "CONFIRMED_CREATE_MEDICINE_TYPE";
export const CONFIRMED_DELETE_MEDICINE_TYPE = "CONFIRMED_DELETE_MEDICINE_TYPE";
export const CONFIRMED_EDIT_MEDICINE_TYPE = "CONFIRMED_EDIT_MEDICINE_TYPE";
